export const isDefined = <T>(arg: T): arg is Exclude<T, undefined> => arg !== undefined
